import React, { useState, useEffect } from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { GalleryVideo } from "../../Components";
export default function ImageSlider({ allInfluencerImage, influencerProfile, setShowActionIcon }) {
  console.log(allInfluencerImage)
  const [batchSize, setBatchSize] = useState(10);
  const [visibleImages, setVisibleImages] = useState(allInfluencerImage.slice(0, batchSize));

  const handleAfterChange = (index) => {
    if (index >= visibleImages.length - 1 && visibleImages.length < allInfluencerImage.length) {
      setTimeout(() => {
        setVisibleImages((prev) => [
          ...prev,
          ...allInfluencerImage.slice(prev.length, prev.length + batchSize)
        ]);
      }, 500); // Simulate loading delay
    }
  };
  var settings = {
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    afterChange: handleAfterChange,
  };
  //console.log(visibleImages)
  return (
    <Slider {...settings}>
      {visibleImages.map((item, index) => {
        return item.media_type_id === 2 ? (<div className="slider-img-wrap">

          <img
            alt={item.media_url}
            src={item.media_url !== "" ? item.media_url : `${process.env.PUBLIC_URL}/images/placeholder/list_image.jpg`
            }
          />
        </div>) : item.media_type_id === 1 ? (
          <GalleryVideo setShowActionIcon={setShowActionIcon} key={item.id} media_url={item.media_url} status={'visible'} media_type_id={item.media_type_id} />
        ) : null;
      })}
    </Slider>
  );
}
